import React, { useEffect, useState } from 'react';
import db from './firebase';
import { collection, getDocs } from 'firebase/firestore';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';


const styles = {
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '250px',
    marginTop: '10px'
  },
  ovalButton: {
    borderRadius: '25px',
    padding: '10px 20px',
    cursor: 'pointer',
    outline: 'none',
    fontWeight: 'bold'
  },
  registerButton: {
    backgroundColor: '#ff6912',
    border: 'none',
    color: 'white',
  },
  requestButton: {
    backgroundColor: '#1259cc',
    border: '2px solid white',
    color: 'white'
  },
  titleWithArrow: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '10px' // space between circle, title, and arrow
  },
  circleIcon: {
    width: '12px',
    height: '12px',
    borderRadius: '50%', // makes it a circle
    backgroundColor: '#1259cc',
    border: '4px solid #ff6912' // border with specified color
  },
  infoContainer: {
    marginLeft: '2.2%',
    marginBottom: '2.2%'  // This will provide minimal spacing between items
  },
  title: {
    margin: '0',  // This removes the default margin of the h4 element
    color: 'white'
  },
  paragraph: {
    margin: '0',  // This removes the default margin of the p elements
    color: '#abddbe'
  },
  body: {
    backgroundColor: '#1259cc',
    flex: 1
  },
  curriculumTitle: {
    color: 'white'
  }
};

function App() {
  const [data, setData] = useState([]);
  const [curriculums, setCurriculums] = useState([]);
  const [expandedCurriculums, setExpandedCurriculums] = useState([]);

  const toggleExpand = (curriculumId) => {
    if (expandedCurriculums.includes(curriculumId)) {
      setExpandedCurriculums(prevState => prevState.filter(id => id !== curriculumId));
    } else {
      setExpandedCurriculums(prevState => [...prevState, curriculumId]);
    }
  };

  useEffect(() => {
    const fetchCurriculums = async () => {
      const dataCollection = collection(db, "curriculums");
      const dataSnapshot = await getDocs(dataCollection);
      const dataList = dataSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      
      const sortedCurriculums = dataList.sort((a, b) => a.position - b.position);
      setCurriculums(sortedCurriculums);
    };

    const fetchData = async () => {
      const dataCollection = collection(db, "events");
      const dataSnapshot = await getDocs(dataCollection);
      const dataList = dataSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setData(dataList);
    };

    fetchCurriculums();
    fetchData();
  }, []);

  return (
    <div className="App" style={styles.body}>
      {curriculums.map(curriculum => (
        <div key={curriculum.id}>
          <div style={styles.titleWithArrow} onClick={() => toggleExpand(curriculum.id)}>
          <div style={{
            ...styles.circleIcon,
            border: curriculum.circleColor ? `4px solid ${curriculum.circleColor}` : styles.circleIcon.border
          }}></div>
            <h1 style={styles.curriculumTitle}>{curriculum.title}</h1>
            {expandedCurriculums.includes(curriculum.id) ? <FaCaretUp color="#ff6912" size="2.5em"/> : <FaCaretDown color="#ff6912" size="2.5em"/>}

          </div>

          
          {expandedCurriculums.includes(curriculum.id) && (
              data.filter(event => event.curriculum === curriculum.title).length > 0 ? (
                  data.filter(event => event.curriculum === curriculum.title).map(matchedEvent => (
                      <div key={matchedEvent.id} style={styles.infoContainer}>
                          <h4 style={styles.title}>{matchedEvent.title}</h4>
                          <p style={styles.paragraph}>Start Date: {matchedEvent.date}</p>
                          <p style={styles.paragraph}>Horario: {matchedEvent.time}</p>
                          
                          <div style={styles.buttonContainer}>
                              <button 
                                  style={{ ...styles.ovalButton, ...styles.registerButton }}
                                  onClick={() => window.open(matchedEvent.registerLink, '_blank')}
                              >
                                  Register Now
                              </button>

                              <button 
                                  style={{ ...styles.ovalButton, ...styles.requestButton }}
                                  onClick={() => window.open(matchedEvent.requestInfoLink, '_blank')}
                              >
                                  Request Info
                              </button>
                          </div>
                      </div>
                  ))
              ) : (
                  <div style={styles.infoContainer}>
                      <h4 style={styles.title}>No courses available...</h4>
                  </div>
              )
          )}

        </div>
      ))}
    </div>
  );
}

export default App;
